module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-modal', {
    staticClass: "loading",
    attrs: {
      "visible": _vm.isShow
    }
  }, [_c('v-ons-progress-circular', {
    staticStyle: {
      "width": "10vh",
      "height": "10vh"
    },
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7fafd82","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/loading.vue
// module id = 541
// module chunks = 0